export const CustomerServiceLinks = [
  {
    id: 1,
    path: '/faq',
    text: 'FAQ'
  },
  {
    id: 2,
    path: '/consultation',
    text: 'Consultation'
  },
  {
    id: 3,
    path: '/contact',
    text: 'Contact'
  },
  {
    id: 4,
    path: '/policies/shipping-and-delivery',
    text: 'Shipping & Delivery'
  }
]
